import React from 'react';
import './Filter.scss';
import { connect } from 'react-redux';
import { setFilter, setSpecialFeatureConsent, setPurposeConsent, setPurposeLegitimateInterest, setAllConsentSwitch, setAllObjectConsentSwitch } from '../../../../redux/actions';
import setVendorListHeight from '../../../../scripts/lib/setVendorListHeight';
import scrollTo from '../../../../scripts/lib/scrollTo';


import numberToAlphabet from '../../../../scripts/lib/numberToAlphabet';
const filtersAllowed = ['specialPurposes','specialFeatures'];

const Filter = props => {

    const defaultSwitchOnClickHandler = (config) => {
        setVendorListHeight(); 

        // props.setAllConsentSwitch(false);
        // props.setAllObjectConsentSwitch(true);
        
        props.setFilter({filterName: config.filterName, value: config.object});
        scrollTo({anchor: '#vendorContainer', x: 0, y: 0});
    }

    //Special
    const specialFeatureSwitchOnChangeHandler = (specialFeatureId) => {
        let specialFeatureOptins = {...props.configuration.specialFeatureOptins};

        if (props.configuration.static && props.configuration.static.specialFeatureOptins && (props.configuration.static.specialFeatureOptins[specialFeatureId] === true || props.configuration.static.specialFeatureOptins[specialFeatureId] === false)) {
            return;
        } else {
            specialFeatureOptins[specialFeatureId] = !specialFeatureOptins[specialFeatureId];
            props.setSpecialFeatureConsent(specialFeatureOptins);
        }
        
    }
    
    const specialFeaturesButton = (config) => {

        return (
            <div className="optinSwitch">
                <div onClick={() => {defaultSwitchOnClickHandler({filterName: config.filterName, object:config.object});}}>

                    {numberToAlphabet(config.id,config.filterName,filtersAllowed)}: {config.name}
                </div>
                <label className="switch">
                    <input type="checkbox" specialfeature-id={config.id} onChange={() => specialFeatureSwitchOnChangeHandler(config.id)} checked={(props.configuration.specialFeatureOptins && props.configuration.specialFeatureOptins[config.id] ) ? true : false}  />
                    <i className="slider blue" />
                </label>
            </div>
        )
    }

    //Purposes
    const purposesButton = (config) => {

        return (
            <div id="purposes">
                <div onClick={() => {defaultSwitchOnClickHandler({filterName: config.filterName, object:config.object});}}>

                    {numberToAlphabet(config.id,config.filterName,filtersAllowed)}: {config.name}
                </div>
                <div id="purposeSwitch">
                    <label className="switch">
                        <input type="checkbox" purposeconsent-id={config.id} onChange={() => purposeConsentSwitchOnChangeHandler(config.id)} checked={(props.configuration.purposeConsent && props.configuration.purposeConsent[config.id] ) ? true : false}  />
                        <i className="slider" />
                    </label>
                    <label className="switch">
                        <input type="checkbox" purposelegitimateinterest-id={config.id} onChange={() => purposeLegitimateInterestSwitchOnChangeHandler(config.id)} checked={(props.configuration.purposeLegitimateInterest && props.configuration.purposeLegitimateInterest[config.id] ) ? true : false}  />
                        <i className="slider orange" />
                    </label>
                </div>
            </div>
        )
    }

    const purposeConsentSwitchOnChangeHandler = (purposeConsentId) => {
        let purposeConsent = {...props.configuration.purposeConsent};

        if (props.configuration.static && props.configuration.static.purposeConsent && (props.configuration.static.purposeConsent[purposeConsentId] === true || props.configuration.static.purposeConsent[purposeConsentId] === false)) {
            return;
        } else {
            purposeConsent[purposeConsentId] = !purposeConsent[purposeConsentId];
            props.setPurposeConsent(purposeConsent);
        }        
    }

    const purposeLegitimateInterestSwitchOnChangeHandler = (purposeLegitimateInterestId) => {
        let purposeLegitimateInterest = {...props.configuration.purposeLegitimateInterest};

        if (props.configuration.static && props.configuration.static.purposeLegitimateInterest && (props.configuration.static.purposeLegitimateInterest[purposeLegitimateInterestId] === true || props.configuration.static.purposeLegitimateInterest[purposeLegitimateInterestId] === false)) {
            return;
        } else {
            purposeLegitimateInterest[purposeLegitimateInterestId] = !purposeLegitimateInterest[purposeLegitimateInterestId];
            props.setPurposeLegitimateInterest(purposeLegitimateInterest);
        }
        
    }

    const renderFilterButtons = (filterName,callback) => {
        return props.currentLanguage.vendorList[filterName].map(object => {
            if (typeof callback === 'function') {
                return (
                    <div className={`filterbuttons ${(props.currentFilter && props.currentFilter.filterName === filterName && object.id === props.currentFilter.value.id) ? 'active' : ''}`} key={`${filterName}_${object.id}`}>
                        {callback({id: object.id, name:object.name, filterName, object})} 
                    </div>
                )
            } else {
                return (
                    <div onClick={() => {defaultSwitchOnClickHandler({filterName, object});}} className={`filterbuttons ${(props.currentFilter && props.currentFilter.filterName === filterName && object.id === props.currentFilter.value.id) ? 'active' : ''}`} key={`${filterName}_${object.id}`}>{numberToAlphabet(object.id,filterName,filtersAllowed)}: {object.name} </div>
                )
            }
        })
    };

    return (
        <div id="filter">
            <h2><strong>{props.currentLanguage.text.labels.purposes}</strong></h2>
            {renderFilterButtons('purposes',purposesButton)}

            <h2><strong>{props.currentLanguage.text.labels.specialPurposes}</strong></h2>
            {renderFilterButtons('specialPurposes')}
            
            <h2><strong>{props.currentLanguage.text.labels.Features}</strong></h2>
            {renderFilterButtons('features')}

            <h2><strong>{props.currentLanguage.text.labels.specialFeatures}</strong><span className="optintext">{props.currentLanguage.text.labels.optIn}</span></h2>
            {renderFilterButtons('specialFeatures',specialFeaturesButton)}
        </div>
    );

};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps, {setFilter, setSpecialFeatureConsent, setPurposeConsent, setPurposeLegitimateInterest, setAllConsentSwitch, setAllObjectConsentSwitch})(Filter);
